import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useMediaQuery,
} from "@chakra-ui/react";
import { faMultiply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function PlaceBar() {
  const navigate = useNavigate();
  const [modal, setModal] = useState(true);
  const closeModal = () => {
    setModal(false);
    navigate("/my_orders");
  };
  const [xl] = useMediaQuery("(min-width: 1280px)");
  const [md] = useMediaQuery("(min-width: 768px)");
  const [sm] = useMediaQuery("(min-width: 640px)");
  const [xs] = useMediaQuery("(min-width: 425px)");
  return (
    <Modal
      isOpen={modal}
      onClose={closeModal}
      size={`${xl ? "3xl" : md ? "2xl" : sm ? "xl" : xs ? "sm" : "xs"}`}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <div
            className="inline border-2 border-black border-opacity-60 px-1.5 float-right 
                rounded-fullest cursor-pointer sm:text-black"
            onClick={closeModal}
          >
            <FontAwesomeIcon
              icon={faMultiply}
              className="text-black text-opacity-60"
            />
          </div>
          <div className="flex flex-col items-center justify-center gap-y-5 py-10">
            <div
              className="text-themeRed border-4 border-themeRed sm:min-w-[80px] min-w-[60px] 
                    sm:min-h-[80px] min-h-[60px] rounded-fullest inline-flex justify-center items-center"
            >
              <FaCheck size={sm ? 48 : 36} />
            </div>
            <h3 className="font-bold text-2xl text-themeBlue text-center">
              Order Placed!
            </h3>
            <p className="font-normal text-lg text-black text-opacity-60 text-center leading-4">
              Your order has been placed, and the waybill has been sent to your
              email.
            </p>
            <div>
              <button
                onClick={closeModal}
                className="font-bold sm:text-xl text-base text-white bg-themeBlue py-3 px-8 rounded-md
                    border-2 border-themeBlue hover:text-themeBlue hover:bg-transparent"
              >
                That's Great
              </button>
            </div>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
